<template>
    <v-form>
        <div>
            <Transition name="spinner">
                <div id="cover-spin"
                     v-if="isLoading">
                    <span class="loader">
                        <span>{{ $spinnerText }}</span>
                    </span>
                </div>
            </Transition>

            <!-- Wybór formatu importu -->
            <div class="grid field-radiobutton"
                 style="margin-bottom:12px">
                <label style="font-weight:bold; margin-right:16px">{{ __('Import format') }}:</label>
                <div style="display:flex; gap:16px">
                    <div class="flex align-items-center">
                        <RadioButton v-model="importFormat"
                                     inputId="format_xlsx"
                                     name="importFormat"
                                     value="xlsx" />
                        <label for="format_xlsx"
                               style="margin-left:4px">Excel (XLSX)</label>
                    </div>
                    <div class="flex align-items-center">
                        <RadioButton v-model="importFormat"
                                     inputId="format_xml"
                                     name="importFormat"
                                     value="xml" />
                        <label for="format_xml"
                               style="margin-left:4px">XML</label>
                    </div>
                </div>
            </div>

            <div class="grid">
                <FormFileUploader fieldName="files"
                                  :label="__('Data file')"
                                  labelStyle="font-weight:bold"
                                  :maxFiles="1"
                                  category="import"
                                  :allowedExtensions="importFormat === 'xlsx' ? ['xlsx'] : ['xml']"
                                  v-model:field="fileToImport" />

            </div>
            <!-- URL dla XML (opcjonalnie, zamiast pliku) -->
            <div v-if="importFormat === 'xml'"
                 class="grid"
                 style="margin: 8px 0 8px 0">
                <label style="font-weight:bold; display:block; margin-bottom:4px">
                    {{ __('or provide a URL to the XML document') }}:
                </label>
                <InputText v-model="xmlUrl"
                           :placeholder="__('https://example.com/data.xml')"
                           style="width:100%;border:1px solid #ccc;padding:6px;border-radius:4px;" />
                <small style="color:#888">{{ __('If you provide a URL, the file is not required') }}</small>
            </div>

            <div class="grid">
                <FormFileUploader fieldName="files"
                                  :label="__('Configuration file (JSON)')"
                                  labelStyle="font-weight:bold"
                                  :maxFiles="1"
                                  category="import"
                                  :allowedExtensions="['json']"
                                  v-model:field="configToImport" />
                <small style="color:#888">{{ __('If the configuration file is missing, the default file (/resources/configurations/import_[table_name].json) will be used') }}</small>
            </div>

        </div>

        <div class="grid">
            <Button severity="success"
                    style="margin:0 8px"
                    @click="makeImport">
                <i class="fa-solid fa-file-arrow-up"
                   style="margin-right:5px;font-size:18px;"></i>
                {{ __('Make import') }}
            </Button>
            <Button severity="secondary"
                    style="margin:0 8px"
                    @click="cancelImport">
                <i class="fa-solid fa-ban"
                   style="margin-right:5px;font-size:18px"></i>
                {{ __('Cancel') }}
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import FormFileUploader from '@pages/Crud/FormFileUploader.vue'
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import RadioButton from 'primevue/radiobutton';
import { __ } from '@pages/Helper/utils.js'

// -----------------------------------------------------
const props = defineProps({
    afterImportFunction: Function,
    importRoute: String,
})

const fileToImport = ref([])
const configToImport = ref([])
const isImportModalOpen = defineModel('isImportModalOpen')
const isLoading = ref(false)
const importFormat = ref('xlsx')
const xmlUrl = ref('')

// -----------------------------------------------------

const cancelImport = () => {
    isImportModalOpen.value = false
}
// -----------------------------------------------------

const makeImport = async () => {
    isLoading.value = true
    await nextTick()                    // ← wymuś render DOM przed requestem, aby loader był widoczny

    const payload = {
        import_format: importFormat.value,
        xml_url: importFormat.value === 'xml' ? xmlUrl.value : null,
    }

    // Jeśli jest załadowany plik, dołącz go
    if (fileToImport.value.import) {
        payload.fileToImport = fileToImport.value.import
    }
    if (configToImport.value.import) {
        payload.configToImport = configToImport.value.import
    }

    useForm(payload).post(route(props.importRoute), {
        preserveState: true,
        preserveScroll: true,
        forceFormData: true,
        onError: (errors) => {
            isImportModalOpen.value = false
            isLoading.value = false
            console.log(errors)
        },
        onFinish: () => {
            isImportModalOpen.value = false
            isLoading.value = false
            props.afterImportFunction()

        }
    })
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
